import React, { useCallback, useMemo, useState } from 'react';
import { useGetColumnConfig, useGetDropdownOption, useGetSampledData } from './hooks';
import { message, Table } from 'antd';
import { dimensionsListSelector } from '@src/store/common/dimensionList/selectors';
import { useSelector } from 'react-redux';
import CustomizeDropdown from '@src/components/common/CustomizeDropdown';
import { notEqualUnknownFilter } from '@src/components/app-analyse-network-request/utils/useTraceId';

const defaultDimensions = ['event_name', 'client_id', 'app_user_id'];

export const SampledViewPanel = ({ dimension }) => {
  const [anchoredDimensions, setAnchoredDimensions] = useState<string[]>([]);
  const [selectedDimensions, setSelectedDimensions] = useState([...defaultDimensions, dimension]);
  const dimensionList = useSelector(dimensionsListSelector);
  const dropdownOptions = useGetDropdownOption(dimensionList, defaultDimensions);
  const [filter, setFilter]: any = useState([notEqualUnknownFilter(dimension)]);
  const { data, isFetching } = useGetSampledData(selectedDimensions, filter);

  const onSearch = useCallback(
    (filterParam) => {
      const tempFilter = [
        notEqualUnknownFilter(dimension),
        [
          {
            field: filterParam.key,
            key: null,
            op: 'contains',
            value: filterParam.text,
            display: filterParam.text,
            originalField: filterParam.key,
            _order: 1,
          },
        ],
      ];
      setFilter(tempFilter);
    },
    [dimension],
  );

  const columns = useGetColumnConfig({
    dimensionList,
    selectedDimensions,
    anchoredDimensions,
    defaultDimensions,
    dimension,
    onSearch,
  });

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          marginBottom: 10,
          marginTop: -10,
          position: 'sticky',
          justifyContent: 'space-between',
        }}
      >
        <CustomizeDropdown
          allMetrics={dropdownOptions}
          anchoredMetrics={[...defaultDimensions, ...anchoredDimensions].reduce((acc, dim) => {
            acc[dim] = true;
            return acc;
          }, {})}
          selectedMetrics={selectedDimensions}
          mandatoryDimensions={[...defaultDimensions, dimension]}
          placeholder="Search Dimension"
          onSelectedMetricsChange={(dims) => {
            if (dims.length > 8) {
              message.info('You can select up to 8 dimensions at a time.');
              return;
            }
            setSelectedDimensions(dims);
            setAnchoredDimensions(anchoredDimensions.filter((d) => dims.includes(d)));
          }}
          onAnchorMetricsChange={(dims) => {
            if (defaultDimensions.includes(dims)) {
              return;
            }
            if (anchoredDimensions.includes(dims)) {
              setAnchoredDimensions(anchoredDimensions.filter((d) => d !== dims));
            } else {
              setAnchoredDimensions([...anchoredDimensions, dims]);
            }
          }}
          maxAnchorCount={7}
        />
        <span style={{ color: '#8c8c8c' }}>
          * High cardinality dimensions only support 24hr data, upto 200 samples
        </span>
      </div>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ x: 'max-content' }}
          loading={isFetching}
          size="small"
          tableLayout="fixed"
        />
      </div>
    </div>
  );
};

export default SampledViewPanel;
